import * as React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

function PointBox({ image = "", title = "", text = "" }) {
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyItems: "center",
      alignItems: 'center',
      gap: '1.5rem',
      width: '100%',
      height: '100%',
    }}>

      <Box sx={{ color: "white", }}>
        <Box
          component="img"
          src={image}
          sx={{
            height: "4.8rem",
            width: "4.8rem",
            display: "flex",
            justifyContent: "center",
            objectFit: "contain",
          }}
          alt=""
        />
      </Box>

      <Typography
        sx={{
          fontSize: "2.4rem",
          fontWeight: 700,
          textAlign: "center",
        }}
      >
        {title}
      </Typography>

      <Typography
        sx={{
          fontSize: "1.6rem",
          fontWeight: 400,
          maxWidth: '28ch',
          textAlign: "center",
          color: "#FFFFFFBF"
        }}
      >
        {text}
      </Typography>
    </Box>

  );
}

PointBox.propTypes = {
  window: PropTypes.func,
};

export default PointBox;